import BlockHorizontalImageCard from './BlockHorizontalImageCard';
export default BlockHorizontalImageCard;